import { accessToken } from '@carvana/core-auth';
import cookieClientToCoreCookieStore from './cookieClientToCoreCookieClient';
import { CookieNames } from '../constants';
import type { CookieClient } from '../types';

export default class LoginCookie {
  private readonly path = '/';

  private readonly isLoggedIn;

  constructor(private cookieClient: CookieClient) {
    this.isLoggedIn = accessToken({
      cookieStore: cookieClientToCoreCookieStore(cookieClient)
    }).isLoggedIn;
  }

  get hasLoggedInCookie() {
    return this.cookieClient.get(CookieNames.MerchHasLoggedIn) === 'true';
  }

  get shouldSetCookie() {
    return this.isLoggedIn && !this.hasLoggedInCookie;
  }

  get shouldRemoveCookie() {
    return !this.isLoggedIn && this.hasLoggedInCookie;
  }

  set(): void {
    this.cookieClient.set(CookieNames.MerchHasLoggedIn, 'true', {
      path: this.path
    });
  }

  remove(): void {
    this.cookieClient.set(CookieNames.MerchHasLoggedIn, '', {
      expires: 'Thu, 01 Jan 1970 00:00:00 UTC',
      path: this.path
    });
  }
}
